module.exports = __webpack_public_path__ + "img/8.1bff4cb4.png";